module.exports = __webpack_public_path__ + "img/产品服务4.2ce02cb5.png";